module.exports = __webpack_public_path__ + "img/DE00526.c251760d.png";